export default __webpack_public_path__ + "static/media/winter3.4b36a2ee.png";